// src/analytics.js
import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-MNH1GBGQCM');
};

export const logPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
